/* KARMA Offer – hero, galleri, faner, antal-trin og 3-trins bundle-flow.
   Data kommer fra <script type="application/json" data-ko-data> i sektionen ko-hero,
   antal-trin fra [data-ko-tiers] og designs fra script[data-ko-design] (theme blocks). */
(function () {
  'use strict';

  var esc = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };
  var fill = function (tpl, map) {
    return String(tpl || '').replace(/\{(\w+)\}/g, function (m, k) { return k in map ? map[k] : m; });
  };

  function moneyFormatter(format, noDecimals) {
    function delimit(cents, precision, thousands, decimal) {
      var n = (cents / 100).toFixed(precision).split('.');
      var whole = n[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return n[1] ? whole + decimal + n[1] : whole;
    }
    return function (cents) {
      cents = Math.round(cents || 0);
      // Uden decimaler: afrund til hele kroner og fjern ",00"
      if (noDecimals) return format_(Math.round(cents / 100) * 100).replace(/[.,]00(?!\d)/, '');
      return format_(cents);
    };
    function format_(cents) {
      return String(format || '{{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
        switch (key) {
          case 'amount_no_decimals': return delimit(cents, 0, ',', '.');
          case 'amount_with_comma_separator': return delimit(cents, 2, '.', ',');
          case 'amount_no_decimals_with_comma_separator': return delimit(cents, 0, '.', ',');
          case 'amount_with_apostrophe_separator': return delimit(cents, 2, "'", '.');
          case 'amount_with_space_separator': return delimit(cents, 2, ' ', ',');
          default: return delimit(cents, 2, ',', '.');
        }
      });
    }
  }

  function addBusinessDays(days) {
    var d = new Date();
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      var wd = d.getDay();
      if (wd !== 0 && wd !== 6) added++;
    }
    return d;
  }
  function formatDate(d) {
    try {
      var lang = document.documentElement.lang || 'da';
      return d.toLocaleDateString(lang, { weekday: 'short', day: 'numeric', month: 'short' });
    } catch (e) { return d.toDateString(); }
  }

  /* ───────── Reservationstimer (delt pr. fane) ───────── */
  function startReserve(root, minutes) {
    var els = root.querySelectorAll('[data-ko-reserve]');
    if (!els.length) return;
    var key = 'ko-reserve-end';
    var end;
    try { end = parseInt(sessionStorage.getItem(key), 10); } catch (e) {}
    var reset = function () {
      end = Date.now() + minutes * 60000;
      try { sessionStorage.setItem(key, end); } catch (e) {}
    };
    if (!end || end < Date.now()) reset();
    var tick = function () {
      var left = end - Date.now();
      if (left <= 0) { reset(); left = end - Date.now(); }
      var t = Math.floor(left / 1000);
      var txt = String(Math.floor(t / 60)).padStart(2, '0') + ':' + String(t % 60).padStart(2, '0');
      els.forEach(function (el) { el.textContent = txt; });
    };
    tick();
    setInterval(tick, 1000);
  }

  function fillDates(root) {
    root.querySelectorAll('[data-ko-date-text]').forEach(function (el) {
      var days = parseInt(el.dataset.days, 10) || 0;
      el.innerHTML = fill(el.dataset.koDateText, { dato: esc(formatDate(addBusinessDays(days))) });
    });
  }

  /* ───────── Galleri ───────── */
  function initGallery(root) {
    var g = root.querySelector('[data-ko-gallery]');
    if (!g) return;
    var track = g.querySelector('[data-track]');
    var slides = g.querySelectorAll('[data-slide]');
    var thumbs = g.querySelectorAll('[data-thumb]');
    var idx = 0;
    var go = function (i) {
      idx = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[idx].offsetLeft, behavior: 'smooth' });
    };
    var prev = g.querySelector('[data-prev]');
    var next = g.querySelector('[data-next]');
    if (prev) prev.addEventListener('click', function () { go(idx - 1); });
    if (next) next.addEventListener('click', function () { go(idx + 1); });
    thumbs.forEach(function (t) { t.addEventListener('click', function () { go(+t.dataset.thumb); }); });
    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        idx = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === idx); });
      });
    });
  }

  function initTabs(root) {
    root.querySelectorAll('[data-ko-tabs]').forEach(function (box) {
      var btns = box.querySelectorAll('[data-tab]');
      var panels = box.querySelectorAll('[data-panel]');
      btns.forEach(function (b) {
        b.addEventListener('click', function () {
          btns.forEach(function (x) { x.classList.toggle('is-active', x === b); });
          panels.forEach(function (p) { p.classList.toggle('is-active', p.dataset.panel === b.dataset.tab); });
        });
      });
      // Temaeditor: vælges en blok inde i en fane, åbnes fanen
      document.addEventListener('shopify:block:select', function (e) {
        var panel = e.target.closest && e.target.closest('[data-panel]');
        if (!panel || !box.contains(panel)) return;
        btns.forEach(function (x) { if (x.dataset.tab === panel.dataset.panel) x.click(); });
      });
    });
  }

  /* ───────── Offer ───────── */
  function Offer(root) {
    var dataEl = root.querySelector('[data-ko-data]');
    if (!dataEl) return;
    var D;
    try { D = JSON.parse(dataEl.textContent); } catch (e) { console.error('[ko-offer] ugyldig data', e); return; }
    this.root = root;
    this.D = D;
    // Antal-trin og designs er theme blocks – de læses fra deres egen markup
    D.tiers = [].map.call(root.querySelectorAll('[data-ko-tiers] [data-qty]'), function (b) {
      return { qty: +b.dataset.qty || 1, pct: +b.dataset.pct || 0, free: +b.dataset.free || 0, label: b.dataset.label || '' };
    });
    var defTier = root.querySelector('[data-ko-tiers] [data-qty][data-default]');
    D.defaultTier = defTier ? +defTier.dataset.tier || 0 : 0;
    D.designs = [];
    root.querySelectorAll('script[data-ko-design]').forEach(function (el) {
      try { D.designs.push(JSON.parse(el.textContent)); } catch (e) { console.error('[ko-offer] ugyldigt design', e); }
    });
    // Knap-priser (antal-trin, CTA, sticky) og flow-priser kan have hver sin decimal-indstilling
    this.moneyOffer = moneyFormatter(D.moneyFormat, D.decimals === 'offer' || D.decimals === 'all');
    this.money = moneyFormatter(D.moneyFormat, D.decimals === 'all');
    this.designs = D.designs || [];
    var dd = root.querySelector('[data-ko-designs-data]');
    this.galleryOn = !dd || dd.dataset.gallery !== 'false';
    this.addLabel = (dd && dd.dataset.addLabel) || 'Tilføj {navn}';
    this.byId = {};
    var self = this;
    this.designs.forEach(function (d) { self.byId[d.id] = d; });
    this.materials = {};
    (D.materials || []).forEach(function (m) { self.materials[m.key] = m; });
    this.tierIdx = Math.min(D.defaultTier || 0, Math.max(0, (D.tiers || []).length - 1));
    this.pieces = []; // [{design, material, size}]
    this.mode = 'same';
    this.same = { material: null, size: null };
    this.view = 'designs';
    this.$ = function (sel) { return root.querySelector(sel); };
    this.flow = this.$('[data-ko-flow]');
    // Flyt flowet til <body>, så det ikke fanges af forældres transform/overflow
    // (sektionens lokale farve-overskrivninger følger med via style-attributten)
    if (this.flow && !Shopify.designMode) {
      this.flow.setAttribute('style', root.getAttribute('style') || '');
      document.body.appendChild(this.flow);
    }
    this.f = function (sel) { return self.flow.querySelector(sel); };
    this.bind();
    this.renderTiers();
  }

  Offer.prototype.tiers = function () { return this.D.tiers || []; };
  Offer.prototype.targetQty = function () { var t = this.tiers()[this.tierIdx]; return t ? t.qty : 1; };
  Offer.prototype.isFree = function () { return this.D.offerType === 'bxgy'; };
  Offer.prototype.pctFor = function (count) {
    var pct = 0;
    this.tiers().forEach(function (t) { if (count >= t.qty && t.pct > pct) pct = t.pct; });
    return this.isFree() ? 0 : pct;
  };
  // Køb X få Y: højeste antal gratis blandt de trin, man har nået
  Offer.prototype.freeFor = function (count) {
    if (!this.isFree()) return 0;
    var free = 0;
    this.tiers().forEach(function (t) { if (count >= t.qty && (t.free || 0) > free) free = t.free; });
    return Math.min(free, count);
  };
  Offer.prototype.countOf = function (id) { return this.pieces.filter(function (p) { return p.design === id; }).length; };

  /* Hero: antal-trin + CTA-pris */
  Offer.prototype.renderTiers = function () {
    var self = this;
    this.root.querySelectorAll('[data-tier]').forEach(function (b) {
      var on = +b.dataset.tier === self.tierIdx;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    var t = this.tiers()[this.tierIdx];
    var qty = t ? t.qty : 1;
    var pct = t ? t.pct : 0;
    var pay = this.isFree()
      ? this.D.currentPrice * Math.max(0, qty - ((t && t.free) || 0))
      : this.D.currentPrice * qty * (100 - pct) / 100;
    var was = this.D.currentCompare * qty;
    var html = (was > pay ? '<s>' + esc(this.moneyOffer(was)) + '</s> ' : '') + '<b>' + esc(this.moneyOffer(pay)) + '</b>';
    this.root.querySelectorAll('[data-ko-cta-price]').forEach(function (el) { el.innerHTML = html; });
    document.dispatchEvent(new CustomEvent('ko:cta', { detail: { priceHtml: html } }));
  };

  Offer.prototype.bind = function () {
    var self = this;
    this.root.querySelectorAll('[data-tier]').forEach(function (b) {
      b.addEventListener('click', function () { self.tierIdx = +b.dataset.tier; self.renderTiers(); });
    });
    this.root.querySelectorAll('[data-ko-open]').forEach(function (b) {
      b.addEventListener('click', function () { self.open(); });
    });
    document.addEventListener('ko:open', function () { self.open(); });
    document.addEventListener('ko:request-cta', function () { self.renderTiers(); });

    this.f('[data-ko-back]').addEventListener('click', function () {
      if (self.view === 'summary') self.show('designs');
      else self.close();
    });
    this.f('[data-ko-next]').addEventListener('click', function () {
      if (self.view === 'designs') self.openSheet();
      else self.checkout();
    });
    this.f('[data-ko-add-more]').addEventListener('click', function () {
      var nt = self.nextTier();
      if (nt) self.tierIdx = nt.idx;
      self.renderTiers();
      self.show('designs');
    });
    this.flow.querySelectorAll('[data-ko-sheet-close]').forEach(function (b) {
      b.addEventListener('click', function () { self.closeSheet(); });
    });
    this.flow.querySelectorAll('[data-ko-mode]').forEach(function (b) {
      b.addEventListener('click', function () { self.mode = b.dataset.koMode; self.renderSheet(); });
    });
    this.f('[data-ko-sheet-done]').addEventListener('click', function () {
      if (!self.allResolved()) return;
      self.closeSheet();
      self.show('summary');
    });
    window.addEventListener('popstate', function () {
      if (self.isOpen) self.close(true);
    });
    // Størrelsesguide: åbn sidens indhold i en popup i stedet for at forlade flowet
    this.flow.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a.ko-guide, a.ko-link');
      if (!a || a.origin !== location.origin || e.metaKey || e.ctrlKey) return;
      e.preventDefault();
      self.openGuide(a.href, a.textContent.replace(/[+\s]+$/, ''));
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !self.isOpen || self.flow.querySelector('.ko-dpop, .ko-gpop')) return;
      if (!self.f('[data-ko-sheet]').hidden) self.closeSheet(); else self.close();
    });
  };

  /* Overskrift/callout i trin 1 og trust-bjælken kommer fra Designs-blokken (<template>s).
     Læses ved hver åbning, så ændringer i temaeditoren slår igennem. */
  Offer.prototype.applyHead = function () {
    var dd = this.root.querySelector('[data-ko-designs-data]');
    if (!dd) return;
    var head = dd.querySelector('template[data-ko-step1-head]');
    var view = this.f('[data-view="designs"]');
    if (head && view) {
      Array.prototype.slice.call(view.children).forEach(function (el) {
        if (el.matches('.ko-s1head, .ko-flow__h')) el.remove();
      });
      view.insertBefore(head.content.cloneNode(true), view.firstChild);
    }
    var bar = dd.querySelector('template[data-ko-flow-bar]');
    if (bar) {
      var old = this.flow.querySelector(':scope > .ko-flow__bar');
      if (old) old.remove();
      var nb = bar.content.querySelector('.ko-flow__bar');
      if (nb) {
        nb = nb.cloneNode(true);
        if (this.fillBar(nb)) this.flow.insertBefore(nb, this.flow.firstChild);
      }
    }
  };

  // Trust-bjælke uden egne tal: brug Rating-blokkens rating og antal (vises ikke uden en rigtig rating)
  Offer.prototype.fillBar = function (bar) {
    var r = this.root.querySelector('.ko-rating');
    var v = bar.querySelector('[data-bar-value]');
    if (v && !v.textContent.trim()) {
      var rv = r && r.querySelector('strong');
      if (!rv || !rv.textContent.trim()) return false;
      v.textContent = rv.textContent.trim();
    }
    var c = bar.querySelector('[data-bar-count]');
    if (c) {
      var txt = '';
      var sep = r && r.querySelector('.ko-rating__sep');
      if (sep && sep.nextElementSibling) txt = sep.nextElementSibling.textContent.trim();
      if (!txt) {
        var total = 0;
        var wrap = (r && r.closest('.ko-rwrap')) || this.root;
        wrap.querySelectorAll('.ko-rpop__c').forEach(function (x) { total += parseInt(x.textContent, 10) || 0; });
        if (total) txt = fill(c.dataset.tpl || '{antal}', { antal: total.toLocaleString(document.documentElement.lang || 'da') });
      }
      if (txt) {
        c.textContent = txt;
        c.hidden = false;
        bar.querySelector('[data-bar-sep]').hidden = false;
      }
    }
    return true;
  };

  Offer.prototype.open = function () {
    if (this.isOpen) return;
    this.isOpen = true;
    this.applyHead();
    this.flow.hidden = false;
    document.documentElement.classList.add('ko-lock');
    try { history.pushState({ ko: 1 }, ''); this.pushed = true; } catch (e) {}
    this.show(this.pieces.length >= this.targetQty() && this.allResolved() ? 'summary' : 'designs');
  };
  Offer.prototype.close = function (fromPop) {
    if (!this.isOpen) return;
    this.isOpen = false;
    this.flow.hidden = true;
    this.f('[data-ko-sheet]').hidden = true;
    document.documentElement.classList.remove('ko-lock');
    if (!fromPop && this.pushed) { this.pushed = false; try { history.back(); } catch (e) {} }
    else this.pushed = false;
  };

  Offer.prototype.show = function (view) {
    this.view = view;
    this.flow.querySelectorAll('[data-view]').forEach(function (v) { v.hidden = v.dataset.view !== view; });
    this.f('[data-ko-totals]').hidden = view !== 'summary';
    this.f('[data-ko-scroll]').scrollTop = 0;
    if (view === 'designs') this.renderDesigns(); else this.renderSummary();
  };

  /* ── Trin 1: designs ── */
  Offer.prototype.renderDesigns = function () {
    var self = this;
    var T = this.D.text;
    var wrap = this.f('[data-ko-designs]');
    wrap.innerHTML = this.designs.map(function (d) {
      var n = self.countOf(d.id);
      var meta = '';
      var left = d.stock == null ? null : Math.max(0, d.stock - n);
      if (left != null && left > 0 && d.stock < self.D.lowStock) {
        var pctBar = Math.max(8, Math.min(100, (left / self.D.lowStock) * 100));
        var cls = left <= self.D.lowStock / 2 ? 'is-low' : 'is-ok';
        meta = '<div class="ko-stock ' + cls + '"><span>' + esc(fill(T.stockLeft, { antal: left })) + '</span><i><b style="width:' + pctBar + '%"></b></i></div>';
      } else if (T.ratingLine) {
        meta = '<div class="ko-drating"><iconify-icon icon="mdi:star" width="16" height="16"></iconify-icon>' + esc(T.ratingLine) + '</div>';
      }
      var canPop = self.hasPop(d);
      return '<div class="ko-dcard' + (n ? ' is-picked' : '') + '" data-id="' + esc(d.id) + '">' +
        (d.badge ? '<span class="ko-dcard__badge">' + esc(d.badge) + '</span>' : '') +
        '<div class="ko-dcard__img' + (canPop ? ' has-pop' : '') + '"' + (canPop ? ' data-pop role="button" tabindex="0" aria-label="Se ' + esc(d.name) + '"' : '') + '>' +
          (d.image ? '<img src="' + esc(d.image) + '" alt="" loading="lazy">' : '') +
          (canPop || d.info ? '<button type="button" class="ko-dcard__info" data-info aria-label="Mere om ' + esc(d.name) + '">i</button>' : '') + '</div>' +
        '<div class="ko-dcard__body"><div class="ko-dcard__name">' + esc(d.name) + '</div>' + meta +
          (d.info && !canPop ? '<div class="ko-dcard__tip" hidden>' + esc(d.info) + '</div>' : '') + '</div>' +
        '<div class="ko-stepper"><button type="button" data-minus aria-label="Fjern">−</button><span>' + n + '</span><button type="button" data-plus aria-label="Tilføj">+</button></div>' +
      '</div>';
    }).join('');
    wrap.querySelectorAll('.ko-dcard').forEach(function (card) {
      var id = card.dataset.id;
      card.querySelector('[data-plus]').addEventListener('click', function () { self.addPiece(id); });
      card.querySelector('[data-minus]').addEventListener('click', function () { self.removePiece(id); });
      var info = card.querySelector('[data-info]');
      var pop = card.querySelector('[data-pop]');
      if (pop) {
        var openIt = function (e) { e.stopPropagation(); self.openPop(id); };
        pop.addEventListener('click', openIt);
        pop.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openIt(e); } });
      } else if (info) info.addEventListener('click', function () {
        var tip = card.querySelector('.ko-dcard__tip');
        tip.hidden = !tip.hidden;
      });
    });
    this.renderNext();
  };

  /* Produkt-popup (ⓘ / klik på billedet): billeder/video, mærker, anmeldelse og Tilføj-knap */
  Offer.prototype.imagesOf = function (d) {
    var out = [];
    var add = function (u) { if (u && out.indexOf(u) < 0) out.push(u); };
    Object.keys(d.products).sort().forEach(function (k) { (d.products[k].images || []).forEach(add); });
    if (!out.length) add(d.image);
    return out;
  };
  Offer.prototype.hasPop = function (d) {
    if (!this.galleryOn) return false;
    var p = d.pop || {};
    return this.imagesOf(d).length > 1 || !!d.video || !!p.text || !!d.info;
  };
  Offer.prototype.openPop = function (id) {
    var self = this;
    var d = this.byId[id];
    if (!d) return;
    var p = d.pop || {};
    var slides = (d.video ? ['<div class="ko-dpop__slide is-video"><video src="' + esc(d.video.src) + '" poster="' + esc(d.video.poster || '') + '" playsinline loop preload="none"></video><button type="button" class="ko-dpop__play" data-play aria-label="Afspil video"><iconify-icon icon="mdi:play" width="30" height="30"></iconify-icon></button></div>'] : [])
      .concat(this.imagesOf(d).map(function (u, i) { return '<div class="ko-dpop__slide"><img src="' + esc(u) + '" alt="" loading="' + (i < 2 ? 'eager' : 'lazy') + '"></div>'; }));
    var badges = (p.badges || []).map(function (b, i) {
      return '<span class="ko-dpop__chip' + (i ? ' is-soft' : '') + '">' + (i ? '' : '<iconify-icon icon="mdi:check-circle" width="18" height="18"></iconify-icon>') + esc(b) + '</span>';
    }).join('');
    var review = p.text
      ? '<div class="ko-dpop__by">' + (p.avatar ? '<img src="' + esc(p.avatar) + '" alt="">' : '') +
          (p.name ? '<strong>' + esc(p.name) + '</strong>' : '') +
          (p.rating ? '<span class="ko-dpop__rate"><iconify-icon icon="mdi:star" width="15" height="15"></iconify-icon>' + esc(p.rating) + '</span>' : '') + '</div>' +
        '<p class="ko-dpop__quote">“' + esc(p.text) + '”</p>'
      : (d.info ? '<p class="ko-dpop__quote">' + esc(d.info) + '</p>' : '');
    var el = document.createElement('div');
    el.className = 'ko-dpop';
    el.innerHTML = '<div class="ko-dpop__backdrop" data-close></div>' +
      '<div class="ko-dpop__panel" role="dialog" aria-modal="true" aria-label="' + esc(d.name) + '">' +
        '<div class="ko-dpop__media">' +
          '<button type="button" class="ko-dpop__close" data-close aria-label="Luk"><iconify-icon icon="mdi:close" width="22" height="22"></iconify-icon></button>' +
          '<div class="ko-dpop__track" data-track>' + slides.join('') + '</div>' +
          (badges ? '<div class="ko-dpop__chips">' + badges + '</div>' : '') +
          (slides.length > 1 ? '<button type="button" class="ko-dpop__arrow ko-dpop__arrow--prev" data-step="-1" aria-label="Forrige"><iconify-icon icon="mdi:chevron-left" width="22" height="22"></iconify-icon></button><button type="button" class="ko-dpop__arrow ko-dpop__arrow--next" data-step="1" aria-label="Næste"><iconify-icon icon="mdi:chevron-right" width="22" height="22"></iconify-icon></button>' : '') +
          (slides.length > 1 ? '<div class="ko-dpop__dots">' + slides.map(function (s, i) { return '<i' + (i ? '' : ' class="is-active"') + '></i>'; }).join('') + '</div>' : '') +
        '</div>' +
        '<div class="ko-dpop__body">' + review +
          '<button type="button" class="ko-dpop__add" data-add><span>' + esc(fill(this.addLabel, { navn: d.name })) + '</span><span class="ko-arr"><iconify-icon icon="mdi:plus" width="24" height="24"></iconify-icon></span></button>' +
        '</div>' +
      '</div>';
    this.flow.appendChild(el);
    var close = function () {
      document.removeEventListener('keydown', onKey);
      el.classList.add('is-closing');
      setTimeout(function () { el.remove(); }, 180);
    };
    var onKey = function (e) { if (e.key === 'Escape') close(); };
    document.addEventListener('keydown', onKey);
    el.querySelectorAll('[data-close]').forEach(function (b) { b.addEventListener('click', close); });
    el.querySelector('[data-add]').addEventListener('click', function () { close(); self.addPiece(id); });
    var play = el.querySelector('[data-play]');
    if (play) play.addEventListener('click', function () {
      var v = el.querySelector('video');
      v.controls = true; v.play(); play.remove();
    });
    var track = el.querySelector('[data-track]');
    var dots = el.querySelectorAll('.ko-dpop__dots i');
    el.querySelectorAll('[data-step]').forEach(function (b) {
      b.addEventListener('click', function () { track.scrollBy({ left: +b.dataset.step * track.clientWidth, behavior: 'smooth' }); });
    });
    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        dots.forEach(function (x, k) { x.classList.toggle('is-active', k === i); });
        var v = el.querySelector('video');
        if (v && i !== 0 && !v.paused) v.pause();
      });
    });
  };

  /* Størrelsesguide i popup: henter siden og viser dens hovedindhold */
  Offer.prototype.openGuide = function (url, title) {
    var self = this;
    var el = document.createElement('div');
    el.className = 'ko-gpop';
    el.innerHTML = '<div class="ko-dpop__backdrop" data-close></div>' +
      '<div class="ko-gpop__panel" role="dialog" aria-modal="true" aria-label="' + esc(title) + '">' +
        '<div class="ko-gpop__head"><strong>' + esc(title) + '</strong>' +
        '<button type="button" class="ko-gpop__close" data-close aria-label="Luk"><iconify-icon icon="mdi:close" width="22" height="22"></iconify-icon></button></div>' +
        '<div class="ko-gpop__body" data-body><div class="ko-gpop__load"></div></div>' +
      '</div>';
    this.flow.appendChild(el);
    var close = function () {
      document.removeEventListener('keydown', onKey);
      el.classList.add('is-closing');
      setTimeout(function () { el.remove(); }, 180);
    };
    var onKey = function (e) { if (e.key === 'Escape') close(); };
    document.addEventListener('keydown', onKey);
    el.querySelectorAll('[data-close]').forEach(function (b) { b.addEventListener('click', close); });
    var body = el.querySelector('[data-body]');
    this.guideCache = this.guideCache || {};
    var show = function (html) { body.innerHTML = html; };
    if (this.guideCache[url]) { show(this.guideCache[url]); return; }
    fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (txt) {
      var doc = new DOMParser().parseFromString(txt, 'text/html');
      var main = doc.querySelector('main') || doc.body;
      main.querySelectorAll('script, noscript, header, footer, .shopify-section-group-header-group, .shopify-section-group-footer-group').forEach(function (n) { n.remove(); });
      // Lazy-billeder skal indlæses med det samme i popuppen
      main.querySelectorAll('img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
      self.guideCache[url] = main.innerHTML;
      show(main.innerHTML);
    }).catch(function () {
      // Kunne ikke hentes – åbn siden i stedet
      close();
      location.href = url;
    });
  };

  Offer.prototype.addPiece = function (id) {
    var d = this.byId[id];
    var keys = Object.keys(d.products);
    var mat = this.same.material && d.products[this.same.material] ? this.same.material : keys[0];
    this.pieces.push({ design: id, material: mat, size: this.same.size });
    this.renderDesigns();
    if (this.D.autoAdvance && this.pieces.length === this.targetQty()) {
      var self = this;
      setTimeout(function () { self.openSheet(); }, 280);
    }
  };
  Offer.prototype.removePiece = function (id, index) {
    var i = typeof index === 'number' ? index : -1;
    if (i < 0) for (var k = this.pieces.length - 1; k >= 0; k--) if (this.pieces[k].design === id) { i = k; break; }
    if (i >= 0) this.pieces.splice(i, 1);
    if (this.view === 'designs') this.renderDesigns(); else this.renderSummary();
  };

  Offer.prototype.renderNext = function () {
    var T = this.D.text;
    var btn = this.f('[data-ko-next]');
    var label = this.f('[data-ko-next-label]');
    var n = this.pieces.length;
    btn.classList.remove('is-checkout');
    if (this.view === 'designs') {
      btn.disabled = n === 0;
      label.textContent = n === 0 ? T.step1Empty : fill(T.step1Next, { antal: n });
    } else {
      btn.disabled = n === 0 || !this.allResolved();
      btn.classList.add('is-checkout');
      label.textContent = T.checkout;
    }
  };

  /* ── Trin 2: materiale & størrelse ── */
  Offer.prototype.productOf = function (p) { var d = this.byId[p.design]; return d && d.products[p.material]; };
  Offer.prototype.variantOf = function (p) {
    var prod = this.productOf(p);
    if (!prod) return null;
    if (!prod.option) return prod.variants[0] && prod.variants[0].available ? prod.variants[0] : null;
    for (var i = 0; i < prod.variants.length; i++) {
      var v = prod.variants[i];
      if (v.value === p.size && v.available) return v;
    }
    return null;
  };
  Offer.prototype.allResolved = function () {
    var self = this;
    return this.pieces.length > 0 && this.pieces.every(function (p) { return !!self.variantOf(p); });
  };

  Offer.prototype.openSheet = function () {
    if (!this.pieces.length) return;
    var sheet = this.f('[data-ko-sheet]');
    sheet.hidden = false;
    this.renderSheet();
  };
  Offer.prototype.closeSheet = function () {
    this.f('[data-ko-sheet]').hidden = true;
    if (this.view === 'designs') this.renderDesigns(); else this.renderSummary();
  };

  Offer.prototype.chips = function (keys, active, attr, disabledFn) {
    var self = this;
    return '<div class="ko-pills">' + keys.map(function (k) {
      var m = self.materials[k] || { name: k };
      var dis = disabledFn ? disabledFn(k) : false;
      return '<button type="button" class="ko-pill' + (k === active ? ' is-active' : '') + '"' + (dis ? ' disabled' : '') + ' ' + attr + '="' + esc(k) + '">' +
        (m.color ? '<i style="background:' + esc(m.color) + '"></i>' : '') + esc(m.name) + '</button>';
    }).join('') + '</div>';
  };
  Offer.prototype.sizeGrid = function (values, active, attr, isAvail) {
    return '<div class="ko-sizes">' + values.map(function (v) {
      var ok = isAvail(v);
      return '<button type="button" class="ko-size' + (v === active ? ' is-active' : '') + '"' + (ok ? '' : ' disabled') + ' ' + attr + '="' + esc(v) + '">' + esc(v) + '</button>';
    }).join('') + '</div>';
  };

  Offer.prototype.renderSheet = function () {
    var self = this;
    var T = this.D.text;
    var box = this.f('[data-ko-options]');
    var single = this.pieces.length < 2;
    if (single) this.mode = 'same';
    this.f('[data-ko-mode-wrap]').hidden = single;
    this.flow.querySelectorAll('[data-ko-mode]').forEach(function (b) { b.classList.toggle('is-active', b.dataset.koMode === self.mode); });

    var html = '';
    var top = '';
    var guide = T.guideUrl ? '<a class="ko-guide" href="' + esc(T.guideUrl) + '" target="_blank" rel="noopener">' + esc(T.guideLabel) + '</a>' : '';
    if (this.mode === 'same') {
      // Materialer der findes i mindst ét valgt design
      var mats = [];
      this.pieces.forEach(function (p) {
        Object.keys(self.byId[p.design].products).forEach(function (k) { if (mats.indexOf(k) < 0) mats.push(k); });
      });
      mats.sort();
      if (!this.same.material || mats.indexOf(this.same.material) < 0) this.same.material = mats[0];
      var missing = [];
      this.pieces.forEach(function (p) {
        var d = self.byId[p.design];
        if (d.products[self.same.material]) p.material = self.same.material;
        else if (missing.indexOf(d.name) < 0) missing.push(d.name);
      });
      if (mats.length > 1) top += this.chips(mats, this.same.material, 'data-same-mat');
      if (mats.length > 1 && missing.length) html += '<p class="ko-note">' + esc(fill(T.unavailable, { materiale: (this.materials[this.same.material] || {}).name || '' })) + ': ' + esc(missing.join(', ')) + '</p>';
      // Størrelser: samlet liste fra alle produkter med varianter
      var sizes = [];
      var label = '';
      this.pieces.forEach(function (p) {
        var prod = self.productOf(p);
        if (!prod || !prod.option) return;
        label = label || prod.option;
        prod.variants.forEach(function (v) { if (sizes.indexOf(v.value) < 0) sizes.push(v.value); });
      });
      if (sizes.length) {
        if (this.same.size && sizes.indexOf(this.same.size) < 0) this.same.size = null;
        this.pieces.forEach(function (p) { if (self.productOf(p) && self.productOf(p).option) p.size = self.same.size; });
        html += '<h3 class="ko-sheet__h">' + esc(T.sizeHeading) + '</h3>' + this.sizeGrid(sizes, this.same.size, 'data-same-size', function (val) {
          return self.pieces.every(function (p) {
            var prod = self.productOf(p);
            if (!prod || !prod.option) return true;
            return prod.variants.some(function (v) { return v.value === val && v.available; });
          });
        });
      }
    } else {
      html += '<div class="ko-each">' + this.pieces.map(function (p, i) {
        var d = self.byId[p.design];
        var prod = self.productOf(p);
        var v = self.variantOf(p);
        var img = (v && v.image) || (prod && prod.image) || d.image;
        var row = '<div class="ko-each__row" data-piece="' + i + '">' +
          '<div class="ko-each__head">' + (img ? '<img src="' + esc(img) + '" alt="">' : '') +
          '<div><small>' + esc(fill(T.piece, { n: i + 1 })) + '</small><strong>' + esc(d.name) + '</strong></div></div>';
        var keys = Object.keys(d.products).sort();
        if (keys.length > 1) row += self.chips(keys, p.material, 'data-each-mat');
        if (prod && prod.option) {
          row += '<div class="ko-each__label">' + esc(prod.option) + '</div>' + self.sizeGrid(prod.variants.map(function (x) { return x.value; }), p.size, 'data-each-size', function (val) {
            return prod.variants.some(function (x) { return x.value === val && x.available; });
          });
        }
        return row + '</div>';
      }).join('') + '</div>';
    }
    box.innerHTML = html;
    var topEl = this.f('[data-ko-toprow]');
    topEl.innerHTML = top || guide ? top + guide : '';
    topEl.querySelectorAll('[data-same-mat]').forEach(function (b) {
      b.addEventListener('click', function () { self.same.material = b.dataset.sameMat; self.renderSheet(); });
    });

    box.querySelectorAll('[data-same-mat]').forEach(function (b) {
      b.addEventListener('click', function () { self.same.material = b.dataset.sameMat; self.renderSheet(); });
    });
    box.querySelectorAll('[data-same-size]').forEach(function (b) {
      b.addEventListener('click', function () { self.same.size = b.dataset.sameSize; self.renderSheet(); });
    });
    box.querySelectorAll('[data-piece]').forEach(function (row) {
      var p = self.pieces[+row.dataset.piece];
      row.querySelectorAll('[data-each-mat]').forEach(function (b) {
        b.addEventListener('click', function () { p.material = b.dataset.eachMat; self.renderSheet(); });
      });
      row.querySelectorAll('[data-each-size]').forEach(function (b) {
        b.addEventListener('click', function () { p.size = b.dataset.eachSize; self.renderSheet(); });
      });
    });
    this.f('[data-ko-sheet-done]').disabled = !this.allResolved();
  };

  /* ── Trin 3: dit sæt ── */
  Offer.prototype.nextTier = function () {
    var n = this.pieces.length;
    var best = null;
    this.tiers().forEach(function (t, i) { if (t.qty > n && (!best || t.qty < best.qty)) best = { qty: t.qty, pct: t.pct, free: t.free || 0, idx: i }; });
    return best;
  };

  Offer.prototype.renderSummary = function () {
    var self = this;
    var T = this.D.text;
    var n = this.pieces.length;
    if (!n) { this.show('designs'); return; }
    var pct = this.pctFor(n);
    var freeN = this.freeFor(n);
    // De billigste smykker bliver gratis (som Shopifys Køb X få Y)
    var freeIdx = this.pieces.map(function (p, i) { var v = self.variantOf(p); return { i: i, price: v ? v.price : 0 }; })
      .sort(function (a, b) { return a.price - b.price; }).slice(0, freeN).map(function (x) { return x.i; });
    var value = 0, pay = 0, base = 0;
    var lines = this.pieces.map(function (p, i) {
      var d = self.byId[p.design];
      var prod = self.productOf(p);
      var v = self.variantOf(p);
      var price = v ? v.price : 0;
      var was = v && v.compare > price ? v.compare : price;
      var isFreeLine = freeIdx.indexOf(i) >= 0;
      var now = isFreeLine ? 0 : Math.round(price * (100 - pct) / 100);
      value += was; pay += now; base += price;
      var mat = (self.materials[p.material] || {}).name || '';
      var meta = [mat, prod && prod.option && p.size ? p.size : ''].filter(Boolean).join(' · ');
      var img = (v && v.image) || (prod && prod.image) || d.image;
      return '<div class="ko-line">' +
        (img ? '<img src="' + esc(img) + '" alt="">' : '<span></span>') +
        '<div class="ko-line__info"><strong>' + esc(d.name) + '</strong><span>' + esc(meta) + '</span>' +
          '<div class="ko-line__acts"><button type="button" data-edit="' + i + '">' + esc(T.edit) + '</button>' +
          (n > 1 ? '<button type="button" data-remove="' + i + '">' + esc(T.remove) + '</button>' : '') + '</div></div>' +
        '<div class="ko-line__price"><strong' + (isFreeLine ? ' class="ko-free"' : '') + '>' + esc(isFreeLine ? (T.free || self.money(0)) : self.money(now)) + '</strong>' + (was > now ? '<s>' + esc(self.money(was)) + '</s>' : '') + '</div>' +
      '</div>';
    }).join('');
    var linesEl = this.f('[data-ko-lines]');
    linesEl.innerHTML = lines;
    linesEl.querySelectorAll('[data-edit]').forEach(function (b) {
      b.addEventListener('click', function () { if (self.pieces.length > 1) self.mode = 'each'; self.openSheet(); });
    });
    linesEl.querySelectorAll('[data-remove]').forEach(function (b) {
      b.addEventListener('click', function () { self.removePiece(null, +b.dataset.remove); });
    });
    this.f('[data-ko-count]').textContent = n;

    var up = this.f('[data-ko-upsell]');
    var nt = this.nextTier();
    if (this.isFree() && nt && (nt.free || 0) > freeN) {
      this.f('[data-ko-upsell-text]').innerHTML = fill(T.upsellFree, { antal: nt.qty, gratis: nt.free });
      up.hidden = false;
    } else if (!this.isFree() && nt && nt.pct > pct) {
      var avg = base / n;
      var extra = base * (nt.pct - pct) / 100 + avg * (nt.qty - n) * nt.pct / 100;
      this.f('[data-ko-upsell-text]').innerHTML = fill(T.upsell, { antal: nt.qty, besparelse: esc(this.money(extra)) });
      up.hidden = false;
    } else up.hidden = true;

    var save = Math.max(0, value - pay);
    this.totals = { value: value, pay: pay, save: save };
    this.f('[data-ko-value]').textContent = this.money(value);
    this.f('[data-ko-save]').textContent = this.money(save);
    this.f('[data-ko-pay]').textContent = this.money(pay);
    var pctEl = this.f('[data-ko-pct]');
    var savePct = value ? Math.round(save / value * 100) : 0;
    pctEl.textContent = savePct ? '-' + savePct + '%' : '';
    pctEl.hidden = !savePct;
    this.renderNext();
  };

  /* ── Kurv ── */
  Offer.prototype.checkout = function () {
    var self = this;
    if (!this.allResolved() || this.busy) return;
    this.busy = true;
    var T = this.D.text;
    var btn = this.f('[data-ko-next]');
    var label = this.f('[data-ko-next-label]');
    btn.disabled = true;
    label.textContent = T.adding;
    var qty = {};
    this.pieces.forEach(function (p) { var v = self.variantOf(p); qty[v.id] = (qty[v.id] || 0) + 1; });
    var tag = 'Sæt ' + this.pieces.length;
    var items = Object.keys(qty).map(function (id) { return { id: +id, quantity: qty[id], properties: { _ko_bundle: tag } }; });
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var drawer = this.D.afterAdd === 'drawer';
    var body = { items: items };
    if (drawer) { body.sections = 'cart-drawer'; body.sections_url = location.pathname; }

    var clear = this.D.clearCart
      ? fetch(root + 'cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
      : Promise.resolve();
    clear.then(function () {
      return fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      });
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Fejl'); return j; });
    }).then(function (j) {
      self.logAdd(tag);
      if (self.D.afterAdd === 'checkout') { self.goCheckout(root + 'checkout'); return; }
      if (drawer && self.openDrawer(j.sections && j.sections['cart-drawer'])) {
        self.busy = false;
        self.close();
        self.renderNext();
        return;
      }
      location.href = root + 'cart';
    }).catch(function (err) {
      console.error('[ko-offer]', err);
      self.busy = false;
      self.renderNext();
      label.textContent = (err && err.message) || T.error;
      setTimeout(function () { self.renderNext(); }, 3500);
    });
  };

  /* Log til Google Sheets (fanen "Kurv") via window.koLog fra snippets/ko-cookie-banner */
  Offer.prototype.logAdd = function (tag) {
    if (typeof window.koLog !== 'function') return;
    var self = this;
    var t = this.totals || {};
    var designs = [], mats = [];
    this.pieces.forEach(function (p) {
      var d = self.byId[p.design];
      if (d) designs.push(d.name);
      var m = (self.materials[p.material] || {}).name;
      if (m && mats.indexOf(m) < 0) mats.push(m);
    });
    var kr = function (c) { return Math.round(c || 0) / 100; };
    try {
      window.koLog({
        event: 'Sæt lagt i kurv', set: tag, pieces: this.pieces.length,
        value: kr(t.value), pay: kr(t.pay), save: kr(t.save),
        designs: designs.join(', '), materials: mats.join(', '), after: this.D.afterAdd || ''
      });
    } catch (e) {}
  };

  /* Direkte til kassen. Temaeditoren blokerer navigation til kassen, og kommer man tilbage
     med browserens tilbage-knap, gendannes siden som den var – begge dele må ikke låse knappen. */
  Offer.prototype.goCheckout = function (url) {
    var self = this;
    var T = this.D.text;
    var btn = this.f('[data-ko-next]');
    var label = this.f('[data-ko-next-label]');
    var unlock = function () {
      self.busy = false;
      btn.onclick = null;
      self.renderNext();
    };
    if (window.Shopify && Shopify.designMode) {
      label.textContent = T.editorNote || 'Lagt i kurven ✓ – kassen åbner ikke i temaeditoren';
      setTimeout(unlock, 4000);
      return;
    }
    location.href = url;
    // Sidder vi her stadig efter 8 sek., bliver knappen et direkte link til kassen (uden at tilføje igen)
    setTimeout(function () {
      if (document.visibilityState === 'hidden') return;
      btn.disabled = false;
      label.textContent = T.checkout;
      btn.onclick = function () { location.href = url; };
    }, 8000);
    if (!this.pageshowBound) {
      this.pageshowBound = true;
      window.addEventListener('pageshow', function (e) { if (e.persisted) unlock(); });
    }
  };

  Offer.prototype.openDrawer = function (html) {
    var live = document.querySelector('theme-drawer#cart-drawer') || document.getElementById('cart-drawer');
    if (!live || !html) return false;
    try {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('theme-drawer#cart-drawer') || doc.getElementById('cart-drawer');
      if (fresh) { live.replaceWith(fresh); live = fresh; }
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));
      setTimeout(function () { if (typeof live.open === 'function') live.open(); else location.href = '/cart'; }, 30);
      return true;
    } catch (e) { return false; }
  };

  /* ───────── Init ───────── */
  function init(scope) {
    (scope || document).querySelectorAll('[data-ko-offer]').forEach(function (root) {
      if (root.dataset.koInit) return;
      root.dataset.koInit = '1';
      if (window.koPrep) window.koPrep(root);
      initGallery(root);
      initTabs(root);
      fillDates(root);
      var data = root.querySelector('[data-ko-data]');
      var mins = 10;
      try { mins = JSON.parse(data.textContent).reserveMinutes || 10; } catch (e) {}
      new Offer(root);
      startReserve(document, mins);
    });
  }
  window.Shopify = window.Shopify || {};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
